import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import MarketTicker from '../components/Nav/MarketTicker';
import './Nav.css';

function Nav() {
  const { isAuthenticated } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className="App-nav">
        <div className="nav-content">
          <div className="nav-left">
            <Link to="/" className="brand-link">
              <img src="/assets/logo_black.svg" alt="Read The Tape" className="nav-logo" />
              <span className="nav-brand">Read The Tape</span>
            </Link>
          </div>

          <div className="nav-center">
            <Link to="/">Home</Link>
            {/*<Link to="/pricing">Pricing</Link>*/}
            {isAuthenticated && <Link to="/account">Account</Link>}
            {isAuthenticated && <Link to="/report">Report</Link>}
            {isAuthenticated && <Link to="/playground">Playground</Link>}
            {!isAuthenticated && <Link to="/login">Login</Link>}
          </div>

          <div className="nav-right">
            {!isAuthenticated ? (
              <Link to="/login" className="cta-button">
                Get Started »
              </Link>
            ) : (
              <Link to="/account" className="cta-button">
                My Account »
              </Link>
            )}
            
            {/* Mobile Menu Button */}
            <button 
              className="mobile-menu-button"
              onClick={toggleMobileMenu}
              aria-label="Toggle navigation menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>

        {/* Mobile Dropdown Menu */}
        {isMobileMenuOpen && (
          <div className="mobile-menu">
            <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
            {/*<Link to="/pricing" onClick={() => setIsMobileMenuOpen(false)}>Pricing</Link>*/}
            {isAuthenticated && <Link to="/account" onClick={() => setIsMobileMenuOpen(false)}>Account</Link>}
            {isAuthenticated && <Link to="/report" onClick={() => setIsMobileMenuOpen(false)}>Report</Link>}
            {isAuthenticated && <Link to="/admin" onClick={() => setIsMobileMenuOpen(false)}>Admin</Link>}
            {isAuthenticated && <Link to="/playground" onClick={() => setIsMobileMenuOpen(false)}>Playground</Link>}
            {!isAuthenticated && <Link to="/login" onClick={() => setIsMobileMenuOpen(false)}>Login</Link>}
          </div>
        )}
      </nav>
      <MarketTicker />
    </>
  );
}

export default Nav;
